export * from '@bit/vibedev.web.components.outlined-inputs';
